// src/Services.js

import React, { useState, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import gdImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/GenralDen.jpg';
import pdtImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Pdt.jpg';
import cdImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/CD.jpg';
import diImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/DI.jpg';
import ldImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/LD.jpg';
import odtImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Odt.jpg';
import onmImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/OnmS.jpg';
import pdImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/PD.jpg';
import ptdtImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Ptdt.jpg';
import rctImage from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/Rct.jpg';
import OurservicesDesk from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/OurServicesDesk.png';
import OurservicesMobile from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/OurServicesMobile.png';
import { useInView } from 'react-intersection-observer';
import Footer from './Footer';



const servicesData = [
    {
        title: "General Dentistry",
        description: (
            <>
             At Aarogyam Dental Care, we offer a wide range of general dental services designed to 
             meet your unique needs and ensure optimal oral health. Our experienced team of dentists 
             is committed to providing personalized care and utilizing the latest dental techniques 
             to deliver exceptional results. We offer comprehensive general dentistry services tailored 
             to your needs. Our experienced dentists provide preventive care, fillings, extractions, root 
             canals, crowns, bridges, sealants, fluoride treatments, and more. Enjoy personalized care, 
             state-of-the-art technology, and a comfortable atmosphere.  

            </>),
        imgSrc: gdImage, // Replace with your image
    },
    {
        title: "Root Canal Treatment",
        description: (
            <>
              Suffering from tooth pain due to damage or infection? At Aarogyam Dental Care, 
              conveniently located in Hyderabad, we offer expert root canal treatment (RCT) 
              to alleviate pain and save your natural teeth. Our experienced dentists utilize 
              advanced techniques and state-of-the-art equipment to perform comfortable and efficient RCT procedures.
               By choosing root canal therapy at our Hyderabad clinic, you can avoid tooth extraction and restore your 
               smile's health and function. We are committed to providing quality endodontic care to the community in Hyderabad.<br></br>

              At Aarogyam Dental Care, we understand the importance of comfortable and effective root canal therapy.
              While our clinic is located in Hyderabad, India, we are committed to providing information about the 
              benefits and process of RCT to those seeking solutions for damaged or infected teeth globally. 
              Modern endodontic techniques and equipment ensure that root canal treatment is a predictable and 
              successful way to restore dental health and eliminate pain.

            </>),
        imgSrc: rctImage, // Replace with your image
    },
    {
        title: "Periodontal treatments ",
        description: (
            <>
              At Aarogyam Dental Care, our periodontists are dedicated to diagnosing, treating,
              and preventing gum disease. Gum disease, if left untreated, can lead to serious oral health problems,
              including tooth loss. Our goal is to provide effective treatment and help you maintain healthy gums and teeth. 

            </>),
        imgSrc: pdtImage, // Replace with your image
    },
    {
        title: "Laser dentistry",
        description: (
            <>
              We offer a modern, minimally invasive approach to various dental treatments.
              Using advanced laser technology, procedures such as teeth whitening, gum reshaping,
              treatment of gum diseases and other minor surgical procedures are performed with precision, 
              reduced discomfort and faster recovery periods.
            </>),
        imgSrc: ldImage, // Replace with your image
    },
    {
        title: "Prosthodontic Treatment",
        description: (
            <>
             Prosthodontic Treatments at Aarogyam Dental Care focus on restoring and replacing missing 
             or damaged teeth to improve both functionality and aesthetics. The clinic offers 
             comprehensive prosthodontic services including Dental Crowns, dentures, fixed dentures, 
             full mouth rehabilitation performed by skilled professionals using the latest technologies. 
             These treatments are tailored to meet the unique needs of each patient, ensuring optimal oral health and comfort.
            </>),
        imgSrc: ptdtImage, // Replace with your image
    },
    {
        title: "Dental implants",
        description: (
            <>
             Dental implants are reliable and long lasting solution for missing teeth. 
             It involves the placement of a titanium screw in the jaw bone, which acts 
             as an artificial tooth root which are then topped with natural looking crowns 
             that blend seamlessly with the surrounding teeth. It provides a durable, comfortable 
             and permanent alternative to traditional dentures or bridges, restoring both the appearance and function of your dentition.
            </>),
        imgSrc: diImage, // Replace with your image
    },
    {
        title: "Cosmetic Dentistry",
        description: (
            <>
             At Aarogyam Dental Care, we believe that a beautiful smile can boost your confidence 
             and overall well-being. Our experienced cosmetic dentists in Hyderabad are dedicated 
             to transforming your smile into a work of art. We have a range of treatments like teeth 
             whitening, Veneers, Smile makeover, etc. Our team of experts ensures personalized cosmetic 
             solutions tailored to each patient’s goals, delivering natural looking results that boost confidence and oral health.
            </>),
        imgSrc: cdImage, // Replace with your image
    },
    {
        title: "Orthodontic treatment",
        description: (
            <>
             Orthodontic treatments are designed to correct misaligned teeth and jaws, 
             enhancing both function and esthetics. We offer a wide range of orthodontic 
             treatment options ranging from traditional braces to Invisalign.  We provide 
             personalized treatment plans that cater to each patient’s unique needs.
            </>),
        imgSrc: odtImage, // Replace with your image
    },
    {
        title: "Pediatric dentistry",
        description: (
            <>
             At Aarogyam Dental Care, we understand the importance of 
             starting your child's dental journey early. Our pediatric dentists 
             are dedicated to providing gentle, compassionate care to ensure your child's oral health is in excellent hands.
            </>),
        imgSrc: pdImage, // Replace with your image
    },
    {
        title: "Oral and maxillofacial surgery",
        description: (
            <>
             Aarogyam dental care offers specialized oral surgery 
             services to address various issues that require surgical intervention. 
             These include wisdom tooth extractions, dental implants, corrective jaw surgeries and treatments for oral diseases or injuries.
            </>),
        imgSrc: onmImage, // Replace with your image
    },

];

const Services = () => {

  const [isMobile, setIsMobile] = useState(false);
    
    const checkDeviceType = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true); // Mobile
      } else {
        setIsMobile(false); // Desktop
      }
    };
  
    // Set up the resize event listener when the component mounts
    useEffect(() => {
      checkDeviceType(); // Check initial screen size
      window.addEventListener('resize', checkDeviceType); // Add resize event listener
  
      // Clean up the event listener on component unmount
      return () => {
        window.removeEventListener('resize', checkDeviceType);
      };
    }, []);

    return (
        <div>
           {isMobile ? (
             <header
             style={{
                 backgroundImage: `url(${OurservicesMobile})`, // Replace with your background image
                 height: '200px',
                 backgroundSize: 'cover',
                 backgroundPosition: 'center',
                 display: 'flex',
                 alignItems: 'center',
                 justifyContent: 'center',
                 color: 'white',
                 textAlign: 'center',
                 width:'100%',
             }}
         >
             {/* <h1>Welcome to Our Services</h1> */}
         </header>
            ) : (
              <header
                style={{
                    backgroundImage: `url(${OurservicesDesk})`, // Replace with your background image
                    height: '150px',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    textAlign: 'center',
                    width: '100%',
                }}
            >
                {/* <h1>Welcome to Our Services</h1> */}
            </header>
            )}
           
            <div className="container mt-5">
                {servicesData.map((service, index) => (
                    <ServiceCard key={index} service={service} index={index} />
                ))}
            </div>
            <Footer/>
        </div>
    );
};

const ServiceCard = ({ service, index }) => {
    const [ref, inView] = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });

    const animation = useSpring({
        transform: inView ? 'translateY(0)' : 'translateY(-50px)',
        opacity: inView ? 1 : 0,
        config: { tension: 280, friction: 60 },
    });

    const isEven = index % 2 === 0;
    const backgroundColor = isEven ? '#f8f9fa' : 'white'; // Grey for even, white for odd

    const [isMobile, setIsMobile] = useState(false);
    
    const checkDeviceType = () => {
      if (window.innerWidth <= 768) {
        setIsMobile(true); // Mobile
      } else {
        setIsMobile(false); // Desktop
      }
    };
  
    // Set up the resize event listener when the component mounts
    useEffect(() => {
      checkDeviceType(); // Check initial screen size
      window.addEventListener('resize', checkDeviceType); // Add resize event listener
  
      // Clean up the event listener on component unmount
      return () => {
        window.removeEventListener('resize', checkDeviceType);
      };
    }, []);
   

    return (
        <animated.div ref={ref} style={animation} className="mb-4">
        <div
          className="card"
          style={{
            borderRadius: '15px',
            backgroundColor,
            border: 'none',
            boxShadow: 'none',
            height: 'auto', // Remove fixed height
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div className="row no-gutters" style={{ height: 'auto' }}>
            {!isMobile ? (
              <>
                {isEven ? (
                  <>
                    <div className="col-md-6" style={{ height: 'auto' }}>
                      <img
                        src={service.imgSrc}
                        alt={service.title}
                        className="img-fluid rounded-left"
                        style={{
                          borderRadius: '15px 0 0 15px',
                          width: '100%',
                          height: 'auto',
                          objectFit: 'cover',
                        }}
                      />
                    </div>
                    <div className="col-md-6 d-flex align-items-center" style={{ height: 'auto' }}>
                      <div className="card-body" style={{ flex: 1 }}>
                        <h3 className="card-title">{service.title}</h3>
                        <p className="card-text">{service.description}</p>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-md-6 d-flex align-items-center" style={{ height: 'auto' }}>
                      <div className="card-body" style={{ flex: 1 }}>
                        <h3 className="card-title">{service.title}</h3>
                        <p className="card-text">{service.description}</p>
                      </div>
                    </div>
                    <div className="col-md-6" style={{ height: 'auto' }}>
                      <img
                        src={service.imgSrc}
                        alt={service.title}
                        className="img-fluid rounded-right"
                        style={{
                          borderRadius: '0 15px 15px 0',
                          width: '100%',
                          height: 'auto',
                          objectFit: 'cover',
                        }}
                      />
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                {/* Image Section */}
                <div className="col-12" style={{ height: 'auto' }}>
                  <img
                    src={service.imgSrc}
                    alt={service.title}
                    className="img-fluid rounded-left"
                    style={{
                      borderRadius: '15px 15px 0 0',
                      width: '100%',
                      height: 'auto',
                      objectFit: 'cover',
                    }}
                  />
                </div>
  
                {/* Text Section */}
                <div className="col-12 d-flex align-items-center" style={{ height: 'auto' }}>
                  <div className="card-body" style={{ flex: 1 }}>
                    <h3 className="card-title">{service.title}</h3>
                    <p className="card-text">{service.description}</p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </animated.div>

    );
};

export default Services;




